module.exports = __webpack_public_path__ + "static/media/room.a2670b50.jpg";